import { useState } from 'react'

export const useStencilCreate = () => {
  const [activeSlug, setActiveSlug] = useState<string | null>(null)

  return {
    activeSlug,
    setActiveSlug,
  }
}

export type StencilContextType = ReturnType<typeof useStencilCreate>
